import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { Integration } from '@sentry/types';
import { browserTracingIntegration } from '@sentry/browser';
import * as Sentry from '@sentry/angular-ivy';
import { environment } from './environments/environment';
import { appVersion } from '../../../src/version';
import gitInfo from '../../../src/git-version.json';
import { enableProdMode } from '@angular/core';

function getSentryIntegrations(): Integration[] {
  return [browserTracingIntegration()];
}

// Sentry
if (environment.sentryEnabled) {
  Sentry.init({
    dsn: environment.sentry_dsn,
    release: gitInfo.hash,

    integrations: getSentryIntegrations(),
    tracePropagationTargets: ['https://dev-api.evermile.io/', 'https://api.prod.evermile.io/'],
    environment: environment.production ? 'Production' : 'Development',

    tracesSampleRate: 1.0,
  });
  Sentry.setContext('version', {
    Version: appVersion,
    Hash: gitInfo.hash,
    BuildTime: gitInfo.time,
  });
}

// Prod mode
if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error());
